module.exports = __webpack_public_path__ + "img/icon-trash-enable.ed36095b.svg";